import { render, staticRenderFns } from "./FractionalBar.vue?vue&type=template&id=2cb4ca70&"
import script from "./FractionalBar.vue?vue&type=script&lang=js&"
export * from "./FractionalBar.vue?vue&type=script&lang=js&"
import style0 from "./FractionalBar.vue?vue&type=style&index=0&id=2cb4ca70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports